import {
  CleanTournament,
  TournamentParticipant,
} from '../../domain/models/tournament.model';
import { AppState } from '../app.state';
import { TournamentState } from './tournament.state';

export const getTournamentState = (state: AppState): TournamentState =>
  state.tournament;

export const getTournaments = (state: AppState): CleanTournament[] | null =>
  state.tournament.tournaments;

export const getUserTournaments = (state: AppState): CleanTournament[] | null =>
  state.tournament.userTournaments;

export const getUserCreatedTournaments = (
  state: AppState,
): CleanTournament[] | null => state.tournament.userCreatedTournaments;

export const getTournamentDetails = (
  state: AppState,
): TournamentParticipant[] | null => state.tournament.tournamentDetails;

export const getTournamentLoading = (state: AppState): boolean =>
  state.tournament.isTournamentLoading;

export const getUserTournamentLoading = (state: AppState): boolean =>
  state.tournament.isUserTournamentLoading;

export const getUserCreatedTournamentLoading = (state: AppState): boolean =>
  state.tournament.isUserCreatedTournamentLoading;

export const getTournamentDetailsLoading = (state: AppState): boolean =>
  state.tournament.isTournamentDetailsLoading;

export const getTournamentError = (state: AppState): string | null =>
  state.tournament.error;

export const getTournamentLastUpdated = (state: AppState): number | null =>
  state.tournament.lastUpdated;
